export const LocationChangeAction = {
    PUSH: 'PUSH',
    REPLACE: 'REPLACE',
    BACK: 'BACK',
    NEW_TAB: 'NEW_TAB',
    RELOAD: 'RELOAD',
    CLOSE: 'CLOSE',
} as const
export const HistoryChangeAction = {
    REMOVE_QUERY: 'REMOVE_QUERY',
    REPLACE_QUERY: 'REPLACE_QUERY',
    REPLACE_STATE: 'REPLACE_STATE',
} as const

export const AlertAction = {
    BROWSER_ALERT: 'ALERT', // window object 내장 alert
} as const

export const ConfirmAction = {
    BROWSER_CONFIRM: 'CONFIRM', // window object 내장 confirm
} as const
